export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const CLEAN_AUTH_DATA = 'CLEAN_AUTH_DATA';

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const CLEAN_AUTH_TOKEN = 'CLEAN_AUTH_TOKEN';